import useTranslation from 'next-translate/useTranslation';
import dayjs from 'dayjs';

//Hooks
import useUser from '@/utils/hooks/swr/useUser';

//Libs
import userDateFormat from '@/lib/user/dateFormat';
import { ACCOUNT } from '@/lib/routes/privateRoutes';

//Components
import { DefaultAvatar } from '@/components/base/Avatar';
import SwitchLightDarkMode from './SwitchLightDarkMode';
import Icon from '@/components/base/Icon';
import LinkBase from '@/components/base/LinkBase';

const HomeHeader = ({ setError }: { setError: (message: string) => void }) => {
    const { t } = useTranslation('home');
    const { user } = useUser();

    return (
        <div className="flex flex-col justify-between gap-1 lg:flex-row lg:items-center">
            <h1 className="w-full truncate font-GBold text-5xl leading-[1.1] lg:mt-0">
                {t('home:header.title', { name: user?.first_name ?? '' })}
            </h1>
            <div className="flex items-center justify-between space-x-5">
                <div className="flex items-center space-x-2.5">
                    <DefaultAvatar
                        fallback={
                            (user?.first_name?.charAt(0) ?? '') + (user?.last_name?.charAt(0) ?? '')
                        }
                        radius="rounded-md"
                        url={user?.settings?.avatar ?? ''}
                    />
                    <div className="space-y-0.5">
                        {user?.first_name || user?.last_name ? (
                            <p className="w-full max-w-[calc(100vw-260px)] truncate text-sm text-icoBlack dark:text-white md:max-w-15">
                                {`${user?.first_name ?? ''} ${user?.last_name ?? ''}`}
                            </p>
                        ) : null}
                        {user?.created_at ? (
                            <p className="w-full whitespace-nowrap font-GMedium text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                                {t('home:header.active_since', {
                                    activeSince: dayjs(user?.created_at).format(
                                        userDateFormat[user?.settings?.date_format]
                                    )
                                })}
                            </p>
                        ) : null}
                    </div>
                </div>
                <div className="flex items-center space-x-5">
                    <hr className="h-5 w-0.5 rounded border-0 bg-icoGray-500 bg-opacity-20 dark:bg-icoDarkMode-wolf" />
                    <SwitchLightDarkMode setError={setError} />
                    <LinkBase href={ACCOUNT}>
                        <div
                            className="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white dark:bg-icoDarkMode-deepBlack"
                            title={t('commons:menu.settings')}>
                            <Icon
                                icon="settings"
                                className="px-0 text-sm text-icoGray-500 dark:text-icoDarkMode-wolf"
                            />
                        </div>
                    </LinkBase>
                </div>
            </div>
        </div>
    );
};

export default HomeHeader;
